import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CardMembershipIcon(props: IconProps) {
    return <Icon {...props} iconKey={"card_membership"}/>
}
